import React, { FC } from "react";
import { Tag } from "../../atoms/Tag";
import { HeaderWrapper, Name } from "./elements";
import arrow_right_circle from "../../../assets/icons/arrow_right_circle.svg";
import { Col, Row } from "antd";

type Props = {
  applicantName: string;
  tag1Color?: string;
  tag1Text: string;
  tag2Color: string;
  tag2Text: string;
  isHoverable?: boolean;
};

const MoveApplicantStatusDetails: FC<Props> = ({
  applicantName,
  tag1Color,
  tag1Text,
  tag2Color,
  tag2Text,
  isHoverable,
}: any) => {
  return (
    <HeaderWrapper>
      <Name>{applicantName}</Name>
      <Row>
        <Col span={11} style={{ textAlign: "right" }}>
          <Tag isHoverable={isHoverable} color={tag1Color} text={tag1Text} />
        </Col>
        <Col span={2}>
          <img src={arrow_right_circle} alt="arrow_right_circle" />
        </Col>
        <Col span={11} style={{ textAlign: "left" }}>
          <Tag isHoverable={isHoverable} color={tag2Color} text={tag2Text} />
        </Col>
      </Row>
    </HeaderWrapper>
  );
};

export default MoveApplicantStatusDetails;
